import { atom } from 'recoil'

export const menuOpenState = atom({
  key: 'menuOpenState',
  default: undefined,
})
